import previewImageUrl from '../../assets/images/unavailability-discovery.svg';
import unavailability1Image from '../../assets/images/premium-features/unavailability-1.svg';
import unavailability2Image from '../../assets/images/premium-features/unavailability-2.svg';
import { PREMIUM_FEATURE_NAMES } from '../../../src/constants';

import unavailabilityPreviewUrl from './unavailabilityPreviewComponent.html';

class UnavailabilityPreviewCtrl {
  previewImageUrl = previewImageUrl;
  unavailability1Image = unavailability1Image;
  unavailability2Image = unavailability2Image;
  UNAVAILABILITY_FEATURE_NAME = PREMIUM_FEATURE_NAMES.unavailability;

  constructor(Authentication) {
    'ngInject';

    Object.assign(this, { Authentication });
  }
}

export default {
  controller: UnavailabilityPreviewCtrl,
  controllerAs: 'ctrl',
  templateUrl: unavailabilityPreviewUrl,
};
